export const transformerMapping = {
  integer: 'onlyNumeric',
  date: 'formatDate',
  iban: 'normalizeIBAN',
  phoneNumber: 'normalizePhone',
  initials: 'normalizeInitials',
};

// DynamicForm data are coming from ZorgWeb where we have no power on valueType to be one of each (look above).
// So only way is to map with the question name since valueType is the same for each field
export const transformerMappingWithName = {
  // 'zorgweb.aanvrager.voorletters': 'normalizeInitials',
  'zorgweb.aanvrager.geboortedatum': 'formatDate',
  // 'zorgweb.partner.voorletters': 'normalizeInitials',
  'zorgweb.partner.geboortedatum': 'formatDate',
  surname: 'capitalize',
  callName: 'capitalize',
};

export default transformerMapping;
